import { render } from "./BaseSelector.vue?vue&type=template&id=5f20a748&scoped=true"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"

import "./BaseSelector.vue?vue&type=style&index=0&id=5f20a748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f20a748"]])

export default __exports__